export interface NavLink {
    label: string;
    component: any;
    permission: TabPermission; 
}

export class PermissionData {
    permission: any;
}

export class TabPermission {
    id: number;
    permissionId: number;
    add: boolean;
    delete: boolean;
    edit: boolean;
    email: boolean;
    print: boolean;
    view: boolean;
}